export interface EnvironmentInfo {
  isMacOS: boolean
  isWindows: boolean
  isLinux: boolean
  isAndroid: boolean
  isIOS: boolean
  isIPad: boolean
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  browser: 'chrome' | 'firefox' | 'safari' | 'edge' | 'opera' | 'unknown'
  isChrome: boolean
  isFirefox: boolean
  isSafari: boolean
  isEdge: boolean
  isOpera: boolean
  touchSupport: boolean
  webGLSupport: boolean
  localStorageSupport: boolean
}

export const userAgent = navigator.userAgent.toLowerCase()
export const platform = navigator.platform?.toLowerCase() || ''

// -------------------- 操作系统检测 --------------------
export const isIPad = (() => {
  if (/ipad/.test(userAgent)) return true
  // iPadOS 13+ 伪装成 Mac，通过触摸点区分
  return /macintosh/.test(userAgent) && navigator.maxTouchPoints > 1
})()

export const isIOS = /iphone|ipod/.test(userAgent) || isIPad
export const isAndroid = /android/.test(userAgent)
export const isMacOS = /macintosh|mac os x/.test(userAgent) && !isIPad
export const isWindows = /windows|win32|win64/.test(userAgent) || /win/i.test(platform)
export const isLinux = /linux/.test(userAgent) && !isAndroid

// -------------------- 设备类型检测 --------------------
export const isMobile = /mobile/.test(userAgent) || isAndroid || isIOS
export const isTablet = (() => {
  if (isIPad) return true
  if (/tablet/.test(userAgent)) return true
  if (isAndroid && !/mobile/.test(userAgent)) return true
  return false
})()
export const isDesktop = !isMobile && !isTablet

// -------------------- 浏览器检测 --------------------
let browser: EnvironmentInfo['browser'] = 'unknown'
if (/edg\//.test(userAgent)) browser = 'edge'
else if (/chrome|chromium|crios/.test(userAgent) && !/edg/.test(userAgent)) browser = 'chrome'
else if (/safari/.test(userAgent) && !/chrome/.test(userAgent)) browser = 'safari'
else if (/firefox|fxios/.test(userAgent)) browser = 'firefox'
else if (/opera|opr/.test(userAgent)) browser = 'opera'

export const isChrome = browser === 'chrome'
export const isFirefox = browser === 'firefox'
export const isSafari = browser === 'safari'
export const isEdge = browser === 'edge'
export const isOpera = browser === 'opera'
export { browser }

// -------------------- 功能特性检测 --------------------
export const touchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0
export const webGLSupport = (() => {
  try {
    const canvas = document.createElement('canvas')
    return !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
  } catch {
    return false
  }
})()
export const localStorageSupport = (() => {
  try {
    return typeof localStorage !== 'undefined' && localStorage !== null
  } catch {
    return false
  }
})()

const env: EnvironmentInfo = {
  isMacOS,
  isWindows,
  isLinux,
  isAndroid,
  isIOS,
  isIPad,
  isMobile,
  isTablet,
  isDesktop,
  browser,
  isChrome,
  isFirefox,
  isSafari,
  isEdge,
  isOpera,
  touchSupport,
  webGLSupport,
  localStorageSupport,
}

export default env
